import styled from "styled-components";

const AboutMainWrap = styled.div`
  padding: 12px 0;
`

export default AboutMainWrap